import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["heading", "onUpdateFilters", "reviewStats"];
import { useTheme } from 'foundations-theming/utils';
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { FavoriteIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import * as LIST_QUERIES from '../constants/ReviewsListQueries';
import { FILTER_KEY } from '../constants/ReviewsListQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OverallDistribution(_ref) {
  let {
      heading,
      onUpdateFilters,
      reviewStats
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const trellisTheme = useTheme();
  const percentages = reviewStats.getOverallPercentages();
  const validFilters = useMemo(() => reviewStats.getValidRatingFilters(), [reviewStats]);
  const renderRatingRow = (stars, value) => {
    const stateValue = LIST_QUERIES.STAR_NUM_TO_STATE.get(stars);
    const isDisabledValue = !validFilters.has(stateValue);
    const onClick = () => onUpdateFilters({
      textKey: FILTER_KEY,
      value: stateValue,
      source: 'overall distribution'
    });
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsxs(Button, {
          use: "transparent",
          onClick: onClick,
          disabled: isDisabledValue,
          children: [/*#__PURE__*/_jsx(Text, {
            as: "span",
            children: stars
          }), /*#__PURE__*/_jsx(View, {
            as: "span",
            marginInline: "100",
            children: /*#__PURE__*/_jsx(FavoriteIcon, {
              color: "fill-accent-yellow-default",
              size: "300"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Flex, {
        marginInlineEnd: "200",
        display: "inline-flex",
        children: /*#__PURE__*/_jsx("span", {
          style: {
            width: '150px'
          },
          children: /*#__PURE__*/_jsx(Progress, {
            marginBlockEnd: "0",
            style: {
              background: trellisTheme.color['icon-tertiary-default']
            },
            value: value
          })
        })
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(Button, {
          use: "transparent",
          onClick: onClick,
          disabled: isDisabledValue,
          children: /*#__PURE__*/_jsx(Text, {
            as: "span",
            children: /*#__PURE__*/_jsx(FormattedPercentage, {
              value: value
            })
          })
        })
      })]
    }, stars);
  };
  return /*#__PURE__*/_jsxs(View, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "body-125",
      children: heading || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.overallDistribution"
      })
    }), percentages && Object.keys(percentages).reverse().map(star => renderRatingRow(star, percentages[star]))]
  }));
}